export enum SoftphoneIntegrationEnum {
  Contacts = 'contacts',
}
